var map = {
	"./symbol_0.png": 2586,
	"./symbol_1.png": 66691,
	"./symbol_10.png": 73515,
	"./symbol_11.png": 9858,
	"./symbol_12.png": 23865,
	"./symbol_13.png": 8112,
	"./symbol_14.png": 3983,
	"./symbol_15.png": 35238,
	"./symbol_16.png": 2653,
	"./symbol_17.png": 81524,
	"./symbol_18.png": 76819,
	"./symbol_2.png": 13480,
	"./symbol_3.png": 23697,
	"./symbol_4.png": 40606,
	"./symbol_5.png": 93095,
	"./symbol_6.png": 90444,
	"./symbol_7.png": 42709,
	"./symbol_8.png": 55506,
	"./symbol_9.png": 70331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38429;